import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Accordion extends Component {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]).isRequired,
    openIcon: PropTypes.string,
    closeIcon: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    isOpen: PropTypes.bool,
    onClick: PropTypes.func
  };

  static defaultProps = {
    children: null,
    openIcon: 'plus',
    closeIcon: 'minus',
    className: null,
    isOpen: false,
    onClick: null
  };

  constructor(props) {
    super(props);
    this.closeWithEscapeKey = this.closeWithEscapeKey.bind(this);
    const { isOpen } = this.props;

    this.state = {
      lastPropValue: isOpen,
      isOpen,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen !== state.lastPropValue) {
      return {
        isOpen: props.isOpen,
        lastPropValue: props.isOpen
      };
    }
    return {
      isOpen: state.isOpen
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.closeWithEscapeKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.closeWithEscapeKey, false);
  }

  closeWithEscapeKey(event) {
    if (event.keyCode === 27) {
      const { onClick } = this.props;
      this.setState({
        isOpen: false
      });

      onClick(false);
    }
  }

  toggle() {
    const { isOpen } = this.state;
    const { onClick } = this.props;
    this.setState({
      isOpen: !isOpen
    });

    if (onClick) {
      onClick(!isOpen);
    }
  }

  render() {
    const { title, openIcon, closeIcon, className, children } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={ `accordion ${ className } ` }>
        <div className={ `header ${ isOpen ? 'open' : '' }` }>
          <button aria-expanded={ isOpen } type="button" className="btn" aria-label="Close" onClick={ () => this.toggle() }>
            <h3>
              { title }
              { children !== '' && <FontAwesomeIcon icon={ isOpen ? closeIcon : openIcon } className="toggle-arrow" /> }
            </h3>
          </button>
        </div>
        <div className={ `accordion-content ${ isOpen ? 'open' : '' }` }>
          <div className="content">
            { children }
          </div>
        </div>
      </div>
    );
  }
}

export default Accordion;
